export default __webpack_public_path__ + "static/media/big_unicorn.595c4996.png";